<template>
    <div
        class="offer_badge_left"
        :style="{ opacity: discountPercentage(product) ? 1 : 0 }"
    >
        <span>On Sale {{ discountPercentage(product) }} OFF</span>
    </div>
</template>

<script>
    export default {
        /* eslint-disable */
        name: "Productoffer",
        /* eslint-enable */
        props: {
            product: {
                required: true
            }
        },
        methods: {
            discountPercentage(product) {
                // Check both singular and plural property names for backward compatibility
                let discountData = product.MainNewProductDiscounts || product.MainNewProductDiscount;

                // If it's an array, get the first active discount
                if (Array.isArray(discountData)) {
                    if (discountData.length === 0) {
                        return "";
                    }
                    // Find active discount (status = 1, promotional_flag = 1)
                    discountData = discountData.find(
                        (discount) => discount.status === 1 && discount.promotional_flag === 1
                    ) || discountData[0];
                }

                // If still no discount data, return empty
                if (!discountData) {
                    return "";
                }

                let promotional_values = discountData;
                let today = new Date();
                // Reset time to start of day for accurate date comparison
                today.setHours(0, 0, 0, 0);

                let enddate = new Date(promotional_values.end_date);
                enddate.setHours(23, 59, 59, 999); // Set to end of day

                let startdate = new Date(promotional_values.start_date);
                startdate.setHours(0, 0, 0, 0); // Set to start of day

                let returnvalue = "";

                // Check if discount is currently active
                if (enddate >= today && startdate <= today) {
                    if (promotional_values.discount_value) {
                        const numValue = Number(promotional_values.discount_value);
                        // Check if it's a whole number
                        if (Number.isInteger(numValue)) {
                            returnvalue = numValue.toString();
                        } else {
                            returnvalue = numValue.toFixed(2);
                        }
                    }
                    if (promotional_values.discount_type == "Flat") {
                        returnvalue = "$" + returnvalue;
                    } else {
                        returnvalue = "" + returnvalue + "%";
                    }
                }
                return returnvalue;
            }
        }
    };
</script>
<style scoped>
    .offer_badge_left {
        position: relative;
        display: inline-flex;
        align-items: center;
        height: 36px;
        padding: 0 12px 0 16px;
        /* left padding slightly more */
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.02em;
        color: #ffffff;
        background-color: #F93333;
        user-select: none;
        clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 10px 50%);
        display: flex;
        margin-left: auto;
        left: inherit;
        z-index: 9;
        max-width: fit-content;
        margin-bottom: 10px;
        opacity: 1;
        transition: opacity 0.2s ease;
        line-height: 24px;
    }

    .offer_badge_left span {
        padding-left: 4px;
       
    }
</style>
